@if (!(hidden | async)) {
    <div class="modal-overlay">
        <div class="modal-backdrop" (click)="close()"></div>

        <div
            class="modal-container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
            cdkTrapFocus
            cdkTrapFocusAutoCapture
        >
            @if (loading) {
                <header class="modal-header">
                    <div class="modal-skeleton__header-title"></div>
                    <div class="modal-header__actions">
                        <div class="modal-skeleton__btn-placeholder"></div>
                        <div
                            class="modal-skeleton__btn-placeholder modal-skeleton__btn-placeholder--sm"
                        ></div>
                    </div>
                </header>
                <div
                    class="modal-skeleton__body"
                    aria-busy="true"
                    aria-live="polite"
                >
                    <span class="sr-only">Loading transaction details</span>
                    @for (block of skeletonBlocks; track $index) {
                        <div class="modal-skeleton__card">
                            <div class="modal-skeleton__card-title"></div>
                            <div class="modal-skeleton__card-grid">
                                @for (line of block; track $index) {
                                    <div class="modal-skeleton__line"></div>
                                }
                            </div>
                        </div>
                    }
                </div>
            } @else if (error) {
                <div class="modal-error">
                    <p class="modal-error__text">{{ error }}</p>
                    <div class="modal-error__actions">
                        @if (canRetry) {
                            <button
                                class="modal-error__retry"
                                (click)="retry()"
                                type="button"
                            >
                                Retry
                            </button>
                        }
                        <button
                            class="modal-error__close"
                            (click)="close()"
                            type="button"
                        >
                            Close
                        </button>
                    </div>
                </div>
            } @else if (details) {
                <header class="modal-header">
                    <h2 id="modal-title" class="modal-header__title">
                        ACH Transaction Details
                        <p class="modal-header__title-subtext">
                            Transaction ID: {{ details.transactionId }}
                        </p>
                    </h2>
                    <div class="modal-header__actions">
                        @if (canExport) {
                            <button
                                class="modal-header__download-btn"
                                (click)="onDownload()"
                                type="button"
                                aria-label="Download transaction details"
                            >
                                <svg
                                    class="modal-header__download-icon"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                    />
                                </svg>
                                DOWNLOAD
                            </button>
                        }
                        <button
                            class="modal-header__close-btn"
                            (click)="close()"
                            aria-label="Close modal"
                            type="button"
                        >
                            <svg
                                class="modal-header__close-icon"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>
                </header>

                <section class="modal-body">
                    @if (details.nocCode && details.nocDate) {
                        <ach-noc-info [details]="details" />
                    }

                    <ach-transaction-overview [details]="details" />

                    <ach-authorization-details [details]="details" />

                    @if (isSourceUnavailable("communications")) {
                        <div class="section-unavailable">
                            <h3 class="section-unavailable__label">
                                Notifications
                            </h3>
                            <p class="section-unavailable__message">
                                Unable to load notifications at this time.
                            </p>
                        </div>
                    } @else {
                        <ach-notification-table
                            [notifications]="details.notifications"
                        />
                    }

                    @if (isSourceUnavailable("payments")) {
                        <div class="section-unavailable">
                            <h3 class="section-unavailable__label">
                                Transaction History
                            </h3>
                            <p class="section-unavailable__message">
                                Unable to load transaction history at this time.
                            </p>
                        </div>
                    } @else {
                        <ach-transaction-history [history]="details.history" />
                    }

                    <ach-related-transactions
                        [relatedTransactions]="details.relatedTransactions"
                        (transactionSelected)="onTransactionSelected($event)"
                    />

                    @if (isSourceUnavailable("exports")) {
                        <div class="section-unavailable">
                            <h3 class="section-unavailable__label">
                                Export History
                            </h3>
                            <p class="section-unavailable__message">
                                Unable to load export history at this time.
                            </p>
                        </div>
                    } @else {
                        <ach-export-history
                            [exportHistory]="details.exportHistory"
                        />
                    }
                </section>
            }
        </div>
    </div>
}
